// extracted by mini-css-extract-plugin
export default {"FlagDanger":"flag_FlagDanger__epMqv","FlagNormal":"flag_FlagNormal__WsxkE"};